module.exports = __webpack_public_path__ + "img/xbody-asset.cb6feadb.svg";